(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2492,6978],{

/***/ 6714:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(4836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(4938));
var _jsxRuntime = __webpack_require__(5893);
var _default = exports.Z = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "m15 5-1.41 1.41L18.17 11H2v2h16.17l-4.59 4.59L15 19l7-7z"
}), 'East');

/***/ }),

/***/ 326:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(4836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(4938));
var _jsxRuntime = __webpack_require__(5893);
var _default = exports.Z = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M3 18h18v-2H3zm0-5h18v-2H3zm0-7v2h18V6z"
}), 'Menu');

/***/ }),

/***/ 8165:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[slug]",
      function () {
        return __webpack_require__(4813);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4208:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ AppWrapperContainer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6886);
/* harmony import */ var _AppNavBar__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7486);



function AppWrapperContainer(param) {
    let { children , nav , navBgColor  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
        sx: {
            paddingTop: {
                xs: "55px",
                md: "72px"
            }
        },
        children: [
            nav ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AppNavBar__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                navBgColor: navBgColor
            }) : null,
            children
        ]
    });
}


/***/ }),

/***/ 2448:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Seo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);


function toRobotsContent(robots) {
    if (!robots) return undefined;
    var _index;
    const index = (_index = robots.index) !== null && _index !== void 0 ? _index : true;
    var _follow;
    const follow = (_follow = robots.follow) !== null && _follow !== void 0 ? _follow : true;
    return "".concat(index ? "index" : "noindex", ", ").concat(follow ? "follow" : "nofollow");
}
function Seo(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
    const description = (ref = props.description) === null || ref === void 0 ? void 0 : ref.trim();
    const canonicalUrl = (ref1 = props.canonicalUrl) === null || ref1 === void 0 ? void 0 : ref1.trim();
    var ref13;
    const ogTitle = (ref13 = (ref2 = props.openGraph) === null || ref2 === void 0 ? void 0 : ref2.title) !== null && ref13 !== void 0 ? ref13 : props.title;
    var ref14;
    const ogDescription = (ref14 = (ref3 = props.openGraph) === null || ref3 === void 0 ? void 0 : ref3.description) !== null && ref14 !== void 0 ? ref14 : description;
    var ref15;
    const ogType = (ref15 = (ref4 = props.openGraph) === null || ref4 === void 0 ? void 0 : ref4.type) !== null && ref15 !== void 0 ? ref15 : "website";
    var ref16;
    const ogUrl = (ref16 = (ref5 = props.openGraph) === null || ref5 === void 0 ? void 0 : ref5.url) !== null && ref16 !== void 0 ? ref16 : canonicalUrl;
    var ref17;
    const twCard = (ref17 = (ref6 = props.twitter) === null || ref6 === void 0 ? void 0 : ref6.card) !== null && ref17 !== void 0 ? ref17 : "summary_large_image";
    var ref18;
    const twTitle = (ref18 = (ref7 = props.twitter) === null || ref7 === void 0 ? void 0 : ref7.title) !== null && ref18 !== void 0 ? ref18 : props.title;
    var ref19;
    const twDescription = (ref19 = (ref8 = props.twitter) === null || ref8 === void 0 ? void 0 : ref8.description) !== null && ref19 !== void 0 ? ref19 : description;
    var ref20;
    const twUrl = (ref20 = (ref9 = props.twitter) === null || ref9 === void 0 ? void 0 : ref9.url) !== null && ref20 !== void 0 ? ref20 : canonicalUrl;
    const robotsContent = toRobotsContent(props.robots);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: props.title
            }, "title"),
            description ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }, "description") : null,
            props.keywords ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: props.keywords
            }, "keywords") : null,
            canonicalUrl ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonicalUrl
            }, "canonical") : null,
            robotsContent ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: robotsContent
            }, "robots") : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: ogTitle
            }, "og:title"),
            ogDescription ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: ogDescription
            }, "og:description") : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: ogType
            }, "og:type"),
            ((ref10 = props.openGraph) === null || ref10 === void 0 ? void 0 : ref10.image) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: props.openGraph.image
                    }, "og:image"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image:secure_url",
                        content: props.openGraph.image
                    }, "og:image:secure_url")
                ]
            }) : null,
            ogUrl ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: ogUrl
            }, "og:url") : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: twCard
            }, "twitter:card"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: twTitle
            }, "twitter:title"),
            twDescription ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: twDescription
            }, "twitter:description") : null,
            ((ref11 = props.twitter) === null || ref11 === void 0 ? void 0 : ref11.image) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: props.twitter.image
            }, "twitter:image") : null,
            twUrl ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:url",
                content: twUrl
            }, "twitter:url") : null,
            (ref12 = props.jsonLd) === null || ref12 === void 0 ? void 0 : ref12.map((block, idx)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    type: "application/ld+json",
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(block)
                    }
                }, "jsonld-".concat(idx))),
            props.children
        ]
    });
}


/***/ }),

/***/ 6978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6886);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5861);
/* harmony import */ var react_responsive_carousel_lib_styles_carousel_min_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2755);
/* harmony import */ var react_responsive_carousel_lib_styles_carousel_min_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_responsive_carousel_lib_styles_carousel_min_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mui_icons_material_East__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6714);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);







function Blogs(param) {
    let { relBlogs , heading  } = param;
    var ref, ref1, ref2, ref3, ref4;
    const [blogs, setBlogs] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (relBlogs) {
            setBlogs(relBlogs);
            return;
        }
        getBlogData();
    }, [
        relBlogs
    ]);
    const getBlogData = async ()=>{
        const RES = await fetch("https://gromo.in/blog/ghost/api/v3/content/posts/?key=e5313c1e06e48b7a7a590f1b1d&include=tags,authors&limit=3").then((res)=>res.json());
        setBlogs(RES.posts);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
        container: true,
        sx: {
            minHeight: "40vh",
            width: "100%",
            justifyContent: "center",
            alignItems: "center",
            padding: {
                xs: "50px 30px",
                md: "60px 0"
            },
            backgroundColor: "#F4F7FF",
            borderRadius: relBlogs && blogs.length ? "15px" : "",
            margin: relBlogs && blogs.length ? "12px 0" : ""
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
            sx: {
                height: "80%",
                width: {
                    xs: "100%",
                    md: "85%"
                },
                maxWidth: "1440px"
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        textAlign: "center",
                        fontWeight: "700",
                        sx: {
                            fontSize: {
                                xs: "24px",
                                md: "40px"
                            }
                        },
                        children: heading
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                    sx: {
                        display: {
                            xs: "none",
                            md: "flex"
                        }
                    },
                    style: {
                        justifyContent: "space-between",
                        alignContent: "center",
                        flexWrap: "wrap"
                    },
                    children: blogs && blogs.length ? blogs.map((blog, i)=>{
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                            sx: {
                                maxHeight: "380px",
                                width: {
                                    xs: "100%",
                                    md: relBlogs && blogs.length ? "300px" : "352px"
                                },
                                display: "flex",
                                margin: "20px 0px",
                                flexDirection: "column",
                                cursor: "pointer",
                                backgroundColor: "white",
                                borderRadius: "10px",
                                boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.15)",
                                justifyContent: "space-between"
                            },
                            onClick: ()=>window.open("https://gromo.in/blog/" + blog.slug),
                            className: "blogCard",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                                    style: {
                                        width: "100%"
                                    },
                                    onClick: ()=>window.open("https://gromo.in/blog/" + blog.slug),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                        src: blog.feature_image,
                                        width: relBlogs && blogs.length ? 300 : 376,
                                        height: 190,
                                        style: {
                                            height: "190px",
                                            width: "376px",
                                            objectFit: "contain",
                                            borderTopLeftRadius: "10px",
                                            borderTopRightRadius: "10px"
                                        },
                                        loading: "lazy",
                                        alt: blog.custom_excerpt || "GroMo"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                                    sx: {
                                        width: "100%",
                                        padding: {
                                            xs: "12px"
                                        },
                                        minHeight: "190px"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                            color: "#6C717F",
                                            children: blog.primary_tag ? blog.primary_tag.name.toUpperCase() : "Saving Account"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                            fontWeight: "bold",
                                            sx: {
                                                fontSize: {
                                                    xs: "20px",
                                                    md: "24px"
                                                }
                                            },
                                            children: blog.title
                                        })
                                    ]
                                })
                            ]
                        }, blog.id);
                    }) : null
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                    sx: {
                        display: {
                            xs: "flex",
                            md: "none"
                        },
                        justifyContent: "center"
                    },
                    children: blogs && blogs.length ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                        sx: {
                            maxHeight: "300px",
                            width: {
                                xs: "100%",
                                md: "300px"
                            },
                            maxWidth: {
                                xs: "300px",
                                md: ""
                            },
                            display: "flex",
                            margin: "20px 0px",
                            flexDirection: "column",
                            cursor: "pointer",
                            backgroundColor: "white",
                            borderRadius: "10px",
                            justifyContent: "space-between",
                            boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.15)"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                                style: {
                                    width: "100%"
                                },
                                onClick: ()=>{
                                    var ref;
                                    window.open("https://gromo.in/blog/" + ((ref = blogs[relBlogs && blogs.length ? 1 : 0]) === null || ref === void 0 ? void 0 : ref.slug));
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                    src: (ref = blogs[relBlogs && blogs.length ? 1 : 0]) === null || ref === void 0 ? void 0 : ref.feature_image,
                                    width: 376,
                                    height: 190,
                                    style: {
                                        height: "190px",
                                        width: "376px",
                                        borderTopLeftRadius: "10px",
                                        borderTopRightRadius: "10px"
                                    },
                                    loading: "lazy",
                                    alt: ((ref1 = blogs[relBlogs && blogs.length ? 1 : 0]) === null || ref1 === void 0 ? void 0 : ref1.custom_excerpt) || "GroMo"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                                style: {
                                    margin: "auto",
                                    padding: 8
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                        sx: {
                                            textAlign: "left"
                                        },
                                        children: ((ref2 = blogs[relBlogs && blogs.length ? 1 : 0]) === null || ref2 === void 0 ? void 0 : ref2.primary_tag) ? (ref3 = blogs[relBlogs && blogs.length ? 1 : 0]) === null || ref3 === void 0 ? void 0 : ref3.primary_tag.name.toUpperCase() : "Saving Account"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                        fontWeight: "bold",
                                        sx: {
                                            textAlign: "left",
                                            fontSize: {
                                                xs: "18px",
                                                md: "24px"
                                            },
                                            lineHeight: {
                                                xs: "30px",
                                                md: "36px"
                                            },
                                            fontWeight: 700
                                        },
                                        children: (ref4 = blogs[relBlogs && blogs.length ? 1 : 0]) === null || ref4 === void 0 ? void 0 : ref4.title
                                    })
                                ]
                            })
                        ]
                    }) : null
                }),
                relBlogs && blogs.length ? null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                    href: "https://gromo.in/blog/",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        textAlign: "center",
                        padding: "8px",
                        color: "#4D71D0",
                        sx: {
                            cursor: "pointer",
                            background: "white",
                            width: "fit-content",
                            margin: "auto",
                            fontSize: "14px",
                            padding: "8px 16px",
                            boxShadow: "0px 1px 4px 0 lightgrey",
                            borderRadius: "8px"
                        },
                        children: [
                            "See more blogs ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_East__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {})
                        ]
                    })
                })
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["default"] = (Blogs);


/***/ }),

/***/ 4813:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(6886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(5861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box = __webpack_require__(4253);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./components/AppWrapperContainer.tsx
var AppWrapperContainer = __webpack_require__(4208);
;// CONCATENATED MODULE: ./public/assets/images/home/more/blog/Icon_LinkedInblog.webp
/* harmony default export */ var Icon_LinkedInblog = ({"src":"/_next/static/media/Icon_LinkedInblog.096e9a5b.webp","height":64,"width":64,"blurDataURL":"data:image/webp;base64,UklGRrQAAABXRUJQVlA4WAoAAAAQAAAABwAABwAAQUxQSDgAAAABN6CgbRumuMqwhPcPjYgIvH1TYBPbVmNNFQIuzNDnPjugjwbYjeh/zPiLAVfDU2AkJA1vwJ39E1ZQOCBWAAAAUAIAnQEqCAAIAAJAOCWoAnS6AAM3yh9/DOsAAPlwm15eJRG02VZeBrlcDMUAx+c21XYK1Kd3kaban0gsbBk9/43qZAKtm+vEweUccz6+bgCFE+KUgAA=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/assets/images/home/more/blog/Icon_Facebookblog.webp
/* harmony default export */ var Icon_Facebookblog = ({"src":"/_next/static/media/Icon_Facebookblog.d018a8db.webp","height":64,"width":64,"blurDataURL":"data:image/webp;base64,UklGRqAAAABXRUJQVlA4WAoAAAAQAAAABwAABwAAQUxQSDgAAAABN6CgbRumuMqwhPcPjYgIvH1TYBPbVmNNFQIuzNDnPjugjwbYjeh/zPiLAVfDU2AkJA1vwJ39E1ZQOCBCAAAAMAIAnQEqCAAIAAJAOCWoAnS6AALJUT4gLMAA+/pwmWU1zdidrfNxPlfNd+FTj3/yVABQ3oA63Xfqbefr4Ap4kAAA","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/assets/images/home/more/blog/Icon_Twitterblog.webp
/* harmony default export */ var Icon_Twitterblog = ({"src":"/_next/static/media/Icon_Twitterblog.52c1f59b.webp","height":64,"width":64,"blurDataURL":"data:image/webp;base64,UklGRrQAAABXRUJQVlA4WAoAAAAQAAAABwAABwAAQUxQSDgAAAABN6CgbRumuMqwhPcPjYgIvH1TYBPbVmNNFQIuzNDnPjugjwbYjeh/zPiLAVfDU2AkJA1vwJ39E1ZQOCBWAAAAMAIAnQEqCAAIAAJAOCWoAnS6AAK62E7MGQAA9qTmMtoDZ7U/sGQiO2Nf6IBg7UtOy9oLwUaOYKoKPEdIoUT//xD2c8VbN9eJg8o45n1+cQCpbKAMAAA=","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/AppFooter.tsx + 6 modules
var AppFooter = __webpack_require__(9705);
// EXTERNAL MODULE: ./components/home/8-blogs/Blogs.tsx
var Blogs = __webpack_require__(6978);
// EXTERNAL MODULE: ./components/Seo.tsx
var Seo = __webpack_require__(2448);
;// CONCATENATED MODULE: ./pages/blog/[slug]/index.tsx
/* provided dependency */ var process = __webpack_require__(3454);












function Slug(props) {
    var ref, ref1, ref2, ref3, ref4;
    const blog = props.blog;
    if (!blog) return null;
    const shareUrl =  true && (window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.href) ? window.location.href : blog.canonical_url;
    const relBlogs = (props.relBlogs || []).filter((item)=>{
        return (item === null || item === void 0 ? void 0 : item.slug) && item.slug !== blog.slug;
    });
    const updateInnerHtml = (html)=>{
        const text = html.replaceAll('href="https://play', "id='onlyHrefRedirectionBlog' href=\"https://").replaceAll("href", "id='onlyHrefBlog' href");
        return {
            __html: text
        };
    };
    const siteUrl = ((ref1 = process.env.NEXT_PUBLIC_SITE_URL) === null || ref1 === void 0 ? void 0 : ref1.replace(/\/+$/, "")) || (()=>{
        try {
            return (blog === null || blog === void 0 ? void 0 : blog.canonical_url) ? new URL(blog.canonical_url).origin : "https://gromo.in";
        } catch (e) {
            return "https://gromo.in";
        }
    })();
    const articleJsonLd = blog ? {
        "@context": "https://schema.org",
        "@type": "BlogPosting",
        "@id": "".concat(blog.canonical_url, "#blogposting"),
        mainEntityOfPage: {
            "@type": "WebPage",
            "@id": blog.canonical_url
        },
        headline: blog.title,
        description: blog.meta_description || blog.custom_excerpt || blog.excerpt || undefined,
        image: blog.feature_image ? [
            blog.feature_image
        ] : undefined,
        datePublished: blog.published_at,
        dateModified: blog.updated_at || blog.published_at,
        author: ((ref2 = blog.primary_author) === null || ref2 === void 0 ? void 0 : ref2.name) ? {
            "@type": "Person",
            name: blog.primary_author.name,
            url: blog.primary_author.url
        } : undefined,
        publisher: {
            "@id": "".concat(siteUrl, "/#organization")
        },
        keywords: Array.isArray(blog.tags) ? blog.tags.filter((_, index, currArr)=>index < currArr.length - 1).map((t)=>t.name).join(",") : undefined
    } : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            blog ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Seo/* default */.Z, {
                title: blog.meta_title || blog.title,
                description: blog.meta_description || blog.custom_excerpt || undefined,
                keywords: blog.tags.filter((_, index, currArr)=>index < currArr.length - 1).map((t)=>t.name).join(","),
                openGraph: {
                    title: blog.og_title || blog.meta_title || blog.title,
                    description: blog.og_description || blog.meta_description || blog.custom_excerpt || undefined,
                    type: "article",
                    image: ((ref3 = blog.og_image) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.toString) === null || ref4 === void 0 ? void 0 : ref4.call(ref3)) || blog.feature_image
                },
                twitter: {
                    title: blog.twitter_title || blog.meta_title || blog.title,
                    description: blog.twitter_description || blog.meta_description || blog.custom_excerpt || undefined,
                    image: blog.twitter_image || blog.feature_image
                },
                jsonLd: articleJsonLd ? [
                    articleJsonLd
                ] : undefined
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AppWrapperContainer/* default */.Z, {
                nav: true,
                navBgColor: "white",
                children: [
                    blog ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                sx: {
                                    minHeight: {
                                        xs: "40vh",
                                        md: "50vh"
                                    },
                                    background: "radial-gradient(37.66% 109.51% at 50% 50%, #718DD9 0%, #4666BD 100%)",
                                    color: "white",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    component: "h1",
                                    sx: {
                                        fontWeight: 700,
                                        fontSize: {
                                            xs: "28px",
                                            md: "64px"
                                        },
                                        lineHeight: {
                                            xs: "36px",
                                            md: "72px"
                                        },
                                        width: {
                                            xs: "80%",
                                            md: "60%"
                                        },
                                        textAlign: "center"
                                    },
                                    children: blog.title
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        sx: {
                                            width: {
                                                xs: "90%",
                                                md: "80%"
                                            },
                                            margin: "20px auto"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            sx: {
                                                width: {
                                                    xs: "100%x",
                                                    md: "550px"
                                                },
                                                margin: "63px auto"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: blog.feature_image,
                                                alt: blog.custom_excerpt || "GroMo",
                                                width: 100,
                                                height: 100,
                                                style: {
                                                    objectFit: "contain",
                                                    width: "100%",
                                                    height: "100%"
                                                },
                                                loading: "lazy"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                        sx: {
                                            width: {
                                                xs: "90%",
                                                md: "80%"
                                            },
                                            margin: "auto",
                                            maxWidth: "1440px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                component: "h2",
                                                sx: {
                                                    fontWeight: 700,
                                                    fontSize: {
                                                        xs: "24px",
                                                        md: "36px"
                                                    },
                                                    lineHeight: {
                                                        xs: "32px",
                                                        md: "38px"
                                                    },
                                                    color: "#0A0C0F",
                                                    margin: "10px 0"
                                                },
                                                children: blog.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                dangerouslySetInnerHTML: updateInnerHtml(blog.html)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                        sx: {
                                            width: {
                                                xs: "90%",
                                                md: "80%"
                                            },
                                            margin: "20px auto",
                                            display: {
                                                xs: "block",
                                                md: "flex"
                                            },
                                            justifyContent: {
                                                xs: "center",
                                                md: "space-between"
                                            },
                                            alignItems: "center",
                                            maxWidth: "1440px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                                sx: {
                                                    display: "flex",
                                                    justifyContent: {
                                                        md: "space-between"
                                                    },
                                                    alignItems: "center"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        variant: "body2",
                                                        sx: {
                                                            fontSize: "14px",
                                                            textAlign: {
                                                                md: "left"
                                                            },
                                                            margin: {
                                                                xs: "5px 0",
                                                                md: "0"
                                                            },
                                                            fontWeight: 700
                                                        },
                                                        children: "share"
                                                    }),
                                                    [
                                                        {
                                                            icon: Icon_Facebookblog,
                                                            link: "http://www.facebook.com/sharer.php?u=".concat(shareUrl)
                                                        },
                                                        {
                                                            icon: Icon_LinkedInblog,
                                                            link: "https://www.linkedin.com/sharing/share-offsite/?url=".concat(shareUrl)
                                                        },
                                                        {
                                                            icon: Icon_Twitterblog,
                                                            link: "https://twitter.com/share?url=".concat(shareUrl)
                                                        }
                                                    ].map((item, i)=>{
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                            sx: {
                                                                height: "32px",
                                                                width: "32px",
                                                                margin: "0px 4px"
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: item.link,
                                                                rel: "preload",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    src: item.icon,
                                                                    alt: "item".concat(i),
                                                                    loading: "lazy"
                                                                })
                                                            })
                                                        }, i);
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                                sx: {
                                                    display: "flex",
                                                    alignItems: {
                                                        md: "center"
                                                    },
                                                    justifyContent: {
                                                        xs: "center",
                                                        md: "normal"
                                                    }
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        variant: "body2",
                                                        fontWeight: 700,
                                                        sx: {
                                                            whiteSpace: "nowrap",
                                                            margin: {
                                                                xs: "8px 0"
                                                            }
                                                        },
                                                        children: "Tags :-"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                        sx: {
                                                            display: "flex",
                                                            flexWrap: {
                                                                xs: "wrap",
                                                                md: "nowrap"
                                                            }
                                                        },
                                                        children: blog.tags.filter((_, index, currArr)=>index < currArr.length - 1).map((item)=>{
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                sx: {
                                                                    padding: "4px 12px",
                                                                    fontSize: {
                                                                        xs: "12px",
                                                                        md: "14px"
                                                                    },
                                                                    borderRadius: "50px",
                                                                    margin: {
                                                                        xs: "4px 8px",
                                                                        md: "4px"
                                                                    },
                                                                    backgroundColor: "#4d71d2",
                                                                    color: "white"
                                                                },
                                                                children: item.name
                                                            }, item.id);
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        sx: {
                                            margin: "auto",
                                            width: "80%"
                                        },
                                        children: relBlogs && relBlogs.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Blogs["default"], {
                                            relBlogs: relBlogs.length === 3 ? relBlogs : relBlogs.slice(0, 3),
                                            heading: "Related Blogs"
                                        }) : null
                                    })
                                ]
                            })
                        ]
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AppFooter["default"], {})
                ]
            })
        ]
    });
}
var __N_SSP = true;
/* harmony default export */ var _slug_ = (Slug);


/***/ }),

/***/ 2755:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3581,6886,6499,5675,7538,5045,9705,7486,9774,2888,179], function() { return __webpack_exec__(8165); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);